import { commandBus } from '@/features/chat'
import { useStudioStore } from '@/store/studio-store'
import { useStudioLocale } from '@/i18n'
import { getDataSurfaceCopy } from '../../data-surface-copy'
import type { FlowEntity } from '../../hooks/use-entity-index'

function selectFlowEntity(f: FlowEntity) {
  commandBus.dispatch({
    type: 'selectEntity',
    payload: { blockName: f.blockName, category: 'flows', name: f.name },
  })
  useStudioStore.getState().selectEntity(f.id)
}

export function FlowTable({ flows }: { flows: FlowEntity[] }) {
  const { locale, strings } = useStudioLocale()
  const copy = getDataSurfaceCopy(locale)
  const fields = strings.dataInspector.fields
  if (flows.length === 0) {
    return <p className="text-xs text-muted-foreground p-4">{copy.emptyTitle.flows}</p>
  }

  return (
    <table className="w-full text-xs">
      <thead>
        <tr className="border-b border-border text-left text-muted-foreground">
          <th className="px-3 py-2 font-medium">{fields.name}</th>
          <th className="px-3 py-2 font-medium">{fields.trigger}</th>
          <th className="px-3 py-2 font-medium">{fields.steps}</th>
        </tr>
      </thead>
      <tbody>
        {flows.map((f) => (
          <tr
            key={f.id}
            className="border-b border-border/50 hover:bg-accent/50 cursor-pointer transition-colors"
            onClick={() => selectFlowEntity(f)}
          >
            <td className="px-3 py-1.5 font-mono text-primary">{f.name}</td>
            <td className="px-3 py-1.5">
              <span className="px-1.5 py-0.5 rounded bg-muted text-muted-foreground">{f.trigger}</span>
            </td>
            <td className="px-3 py-1.5 text-muted-foreground">{f.stepCount} steps</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
